export const capitalizeFirstLetter = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1)
}

export const removeSpecialsAndWhitespaces = (str: string) => str.replace(/[^A-Z0-9]/gi, '')

export const detectNewline = (str: string) => {
	return str.replace(/\n/g, '<br/>')
}

export const returnCurrentURL = (route: any) => {
	return route.fullPath
}
